{
  "version": 1,
  "asset_id": "65f377db-ea96-4322-8749-03097ef2883a",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/65f377db-ea96-4322-8749-03097ef2883a/dzien-dobry-poster.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/65f377db-ea96-4322-8749-03097ef2883a/dzien-dobry-poster.jpg",
  "original_filename": "dzien-dobry-poster.jpg",
  "size": 60725,
  "content_type": "image/jpeg",
  "created_at": "2026-09-30T11:50:09Z"
}
